(function () {
  'use strict';

  /* Scroll reveal */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.sat-rv:not([data-rv-bound])');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { el.setAttribute('data-rv-bound', '1'); io.observe(el); });
  }

  /* Accordion: only one open at a time within a group */
  function initAccordion(root) {
    var groups = (root || document).querySelectorAll('[data-sat-accordion]:not([data-acc-bound])');
    groups.forEach(function (group) {
      group.setAttribute('data-acc-bound', '1');
      var items = group.querySelectorAll('details');
      items.forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (!d.open) return;
          items.forEach(function (o) { if (o !== d) o.open = false; });
        });
      });
    });
  }

  /* Tabs (mechanism section) */
  function initTabs(root) {
    var sets = (root || document).querySelectorAll('[data-sat-tabs]:not([data-tabs-bound])');
    sets.forEach(function (set) {
      set.setAttribute('data-tabs-bound', '1');
      var btns = set.querySelectorAll('[data-tab-btn]');
      var panes = set.querySelectorAll('[data-tab-pane]');
      btns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var id = btn.getAttribute('data-tab-btn');
          btns.forEach(function (b) {
            var on = b === btn;
            b.classList.toggle('is-active', on);
            b.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          panes.forEach(function (p) { p.hidden = p.getAttribute('data-tab-pane') !== id; });
        });
        btn.addEventListener('keydown', function (ev) {
          if (ev.key !== 'ArrowRight' && ev.key !== 'ArrowLeft') return;
          ev.preventDefault();
          var arr = Array.prototype.slice.call(btns);
          var i = arr.indexOf(btn);
          var next = arr[(i + (ev.key === 'ArrowRight' ? 1 : -1) + arr.length) % arr.length];
          next.focus(); next.click();
        });
      });
    });
  }

  /* Move a horizontal scroller. Smoothness comes from CSS scroll-behavior,
     not a hand-rolled tween: rAF does not run in a hidden or background tab
     and timers get throttled, which can leave a carousel wedged mid-slide. */
  function glide(el, target) {
    var max = Math.max(0, el.scrollWidth - el.clientWidth);
    el.scrollLeft = Math.max(0, Math.min(target, max));
  }

  /* Product media gallery */
  function initGallery(root) {
    var tracks = (root || document).querySelectorAll('slideshow-slides:not([data-sat-gal])');
    tracks.forEach(function (track) {
      track.setAttribute('data-sat-gal', '1');
      var scope = track.closest('slideshow-component') || document;
      var btns = scope.querySelectorAll('[on\\:click]');
      var prev = scope.querySelectorAll('.slideshow-control--previous');
      var next = scope.querySelectorAll('.slideshow-control--next');

      function indexOf(btn) {
        var m = (btn.getAttribute('on:click') || '').match(/\/select\/(\d+)/);
        return m ? parseInt(m[1], 10) : null;
      }
      function sync() {
        var max = track.scrollWidth - track.clientWidth;
        prev.forEach(function (b) { b.classList.toggle('sat-arrow-off', track.scrollLeft <= 4); });
        next.forEach(function (b) { b.classList.toggle('sat-arrow-off', track.scrollLeft >= max - 4); });
        var current = Math.round(track.scrollLeft / (track.clientWidth || 1));
        btns.forEach(function (b) {
          var i = indexOf(b);
          if (i !== null) b.setAttribute('aria-selected', i === current ? 'true' : 'false');
        });
      }

      btns.forEach(function (btn) {
        var action = btn.getAttribute('on:click') || '';
        btn.addEventListener('click', function () {
          var i = indexOf(btn);
          if (i !== null) {
            var slide = track.children[i];
            if (slide) glide(track, slide.offsetLeft - track.offsetLeft);
          } else if (action.indexOf('/next') > -1) {
            glide(track, track.scrollLeft + track.clientWidth);
          } else if (action.indexOf('/previous') > -1) {
            glide(track, track.scrollLeft - track.clientWidth);
          }
          setTimeout(sync, 80);
          setTimeout(sync, 600);
        });
      });

      var t;
      track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(sync, 90); }, { passive: true });
      window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(sync, 150); });
      sync();
    });
  }

  /* Reels strip.
     The arrows wrap around rather than dead-ending, so it behaves as an
     endless loop in both directions. Cards are not cloned on purpose:
     duplicating them would double the number of videos the browser loads. */
  function initReels(root) {
    var strips = (root || document).querySelectorAll('[data-sat-reels]:not([data-reels-nav])');
    strips.forEach(function (strip) {
      strip.setAttribute('data-reels-nav', '1');
      var wrap = strip.closest('.sat-rl');
      if (!wrap) return;
      var prev = wrap.querySelector('.sat-rl__nav--prev');
      var next = wrap.querySelector('.sat-rl__nav--next');
      var cards = strip.querySelectorAll('.sat-rl__card');
      if (!cards.length) return;

      function maxScroll() { return Math.max(0, strip.scrollWidth - strip.clientWidth); }
      function step() {
        var a = cards[0].getBoundingClientRect().width;
        var gap = cards.length > 1 ? (cards[1].getBoundingClientRect().left - cards[0].getBoundingClientRect().right) : 16;
        return a + (gap > 0 ? gap : 16);
      }
      function go(dir) {
        var max = maxScroll();
        if (max <= 0) return;                       /* everything already fits */
        var target = strip.scrollLeft + dir * step();
        if (dir > 0 && strip.scrollLeft >= max - 4) target = 0;        /* loop to start */
        else if (dir < 0 && strip.scrollLeft <= 4) target = max;       /* loop to end */
        glide(strip, target);
      }
      function sync() {
        /* Arrows stay live because the strip loops. They only disappear when
           there is genuinely nothing to scroll. */
        var none = maxScroll() <= 0;
        if (prev) prev.classList.toggle('sat-arrow-off', none);
        if (next) next.classList.toggle('sat-arrow-off', none);
      }

      if (prev) prev.addEventListener('click', function () { go(-1); setTimeout(sync, 80); });
      if (next) next.addEventListener('click', function () { go(1); setTimeout(sync, 80); });

      var t;
      strip.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(sync, 90); }, { passive: true });
      window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(sync, 150); });
      sync();
    });
  }

  function boot(root) {
    initReveal(root); initAccordion(root); initTabs(root); initGallery(root); initReels(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
